import type { AsyncSequence } from "../types/AsyncSequence"

/**
 * Creates ReadableStream from async iterable of byte arrays.
 *
 * Converts AsyncSequence<Uint8Array> to Web Streams API ReadableStream.
 *
 * @param body - Async sequence of Uint8Array chunks
 * @param cancel - Optional cancellation callback
 * @returns ReadableStream for use with Response or other stream consumers
 *
 * @example
 * ```ts
 * import { StreamCreate } from "@pdfking/tfunc"
 *
 * const stream = StreamCreate(async function*() {
 *   yield new Uint8Array([1, 2, 3])
 * }())
 * const response = new Response(stream)
 * ```
 */
export const StreamCreate = (
  body: AsyncSequence<Uint8Array>,
  cancel?: () => void
): ReadableStream =>
  new ReadableStream({
    cancel,
    async start(controller) {
      for await (const bytes of body) controller.enqueue(bytes)
      controller.close()
    },
  })
